<template>
  <div>
    <my-header></my-header>
  
      <div class="content-container-level-1">
      <h2>M3 Replays</h2>
      </div>


      <loading-indicator v-if="isLoading"/>

      <template v-if="!isLoading && filtered != nil">
      <div class="content-container-level-0">
      <div class="mb-2">
        <b-button-group>
        <b-button href='#' variant='primary' v-on:click="downloadAll">Download all ({{checkedReplays.length}}) as file</b-button>
        <b-button href='#' variant='primary' v-on:click="copyAllToClipboard">Copy all ({{checkedReplays.length}}) to clipboard</b-button>
        </b-button-group>
      </div>
      <div class="mb-2">
        <b-form inline @submit.prevent="filter">
          <label class="sr-only" for="start_time">Start time</label>
          <b-form-input
            id="start_time"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Start date/time"
            v-model="filter_start_time"
          ></b-form-input>

          <label class="sr-only" for="end_time">End time</label>
          <b-form-input
            id="end_time"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="End date/time"
            v-model="filter_end_time"
          ></b-form-input>

          <label class="sr-only" for="seed">Seed</label>
          <b-form-input
            id="seed"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Seed"
            v-model="filter_seed"
          ></b-form-input>

          <label class="sr-only" for="level_id">Level id</label>
          <b-form-input
            id="level_id"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Level id"
            v-model="filter_level_id"
          ></b-form-input>

          <label class="sr-only" for="client_ver">Client ver</label>
          <b-form-input
            id="client_ver"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Client version"
            v-model="filter_client_ver"
          ></b-form-input>

          <b-button class="mb-2 mr-sm-2 mb-sm-0" variant="primary" v-on:click="filter">Filter</b-button>
          <b-button class="mb-2 mr-sm-2 mb-sm-0" variant="primary" v-on:click="resetFiltered">Reset</b-button>
        </b-form>
      </div>

      <div class="content-container-level-1">
      <table class="table table-bordered replays-table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Time</th>
            <th scope="col">Level</th>
            <th scope="col">Seed</th>
            <th scope="col">Win?</th>
            <th scope="col">Client Ver.</th>
            <th scope="col">Player id</th>
            <th scope="col">Events num</th>
            <th scope="col"><input type="checkbox" v-model="checkedAll" @change="checkAll()"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in filtered.Items"
            :key="item.Data.t"
          >
            <td>{{index+1}}</td>
            <td>{{item.Data.t | getMomentStr}}</td>
            <td>{{item.Decoded.level_conf_strid}} <small>{{item.Data.lid}}</small></td>
            <td>{{item.Decoded.rand_seed}}</td>
            <td>{{item.Data.win}}</td>
            <td>{{item.Data.cver}}</td>
            <td>{{item.Data.plrid}}</td>
            <td>{{item.Decoded.events.length}}</td>
            <td>
            <input type="checkbox"  v-bind:true-value=1 v-bind:id="index" v-bind:value="index" v-model="checkedReplays">
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      </div>
      </template>

  </div>
</template>

<script>
import auth from '../auth';
import moment from 'moment';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import saveAs from 'file-saver';

export default {
  components: {
    MyHeader,
    LoadingIndicator
  },

  data() {
    return {
      viewer: auth.getViewer(),
      isLoading: false,
      replays: null,
      checkedReplays: [],
      checkedAll: true,
      filtered: null,
      filter_start_time: "",
      filter_end_time: "",
      filter_seed: "",
      filter_level_id: "",
      filter_client_ver: "",
    };
  },

  methods: {
    filter() {
      this.resetFiltered();

      //const TEMPLATE = 'YYYY.MM.DD HH:mm:ss';
      const TEMPLATE = 'DD/MM/YYYY HH:mm:ss';
      var moment_start = moment(this.filter_start_time, TEMPLATE);
      var moment_end = moment(this.filter_end_time, TEMPLATE);

      for(var i=this.filtered.Items.length;i-- > 0;)
      {
        var item =this.filtered.Items[i];
        var item_stamp = moment(item.Data.t*1000);

        var remove = false;

        remove |= moment_start != null && item_stamp.valueOf() < moment_start.valueOf();
        remove |= moment_end != null && item_stamp.valueOf() > moment_end.valueOf();
        remove |= this.filter_seed !== "" && item.Decoded.rand_seed != parseInt(this.filter_seed);
        remove |= this.filter_level_id !== "" && item.Data.lid != parseInt(this.filter_level_id);
        remove |= this.filter_client_ver !== "" && item.Data.cver != this.filter_client_ver;

        if(remove)
          this.filtered.Items.splice(i, 1);
      }

      this.checkReplays();

    },

    checkAll() {
      if(this.checkedAll)
        this.checkReplays();
      else
        this.checkedReplays = [];
    },

    makeAllJson() {
      var content = "{\"r64s\" : [";
      for(var i=0;i<this.filtered.Items.length;i++)
      {
        if(this.checkedReplays.indexOf(i) == -1)
          continue;

        content += '"' + this.filtered.Items[i].Data.r64 + '"';
        if(i < this.filtered.Items.length-1)
          content += ",";
      }
      content += "]}";
      return content
    },

    copyToClipboard(str) {
      navigator.clipboard.writeText(str)
    },

    copyAllToClipboard() {
      navigator.clipboard.writeText(this.makeAllJson())
    },

    downloadAll() {
      var blob = new Blob([this.makeAllJson()], {
        type: "text/plain;charset=utf-8"
      });

      var d = new Date();
      const offset = d.getTimezoneOffset()
      d = new Date(d.getTime() - (offset*60*1000))
      const file_name = d.toISOString().split('T')[0] + "-m3-replays.txt";

      saveAs(blob, file_name);
    },

    resetFiltered() {
      this.filtered = {"Items": []}
      for(var i=0;i<this.replays.Items.length;i++)
        this.filtered.Items.push(this.replays.Items[i]);

      this.checkReplays();
    },

    checkReplays() {
      this.checkedReplays = [];
      for(var f=0;f<this.filtered.Items.length;++f)
        this.checkedReplays.push(f);
    }
  },

  created() {
    this.isLoading = true;

    const url = '/m3_replays';
    HTTP.get(url)
    .then(response => {
      const data = response.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.replays = data;
      this.resetFiltered();

    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};

</script>

<style scoped>
  h2 {
    margin-bottom: 0.6em;
  }
</style>
